import React from 'react';
import { MapPin } from 'lucide-react';
import { companyInfo } from '../../data/mockData';
import { SocialIcons } from '../SocialIcons';

export const FooterCompany = () => (
  <div className="footer-section">
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
      <img
        src="https://customer-assets.emergentagent.com/job_dba9b77f-2bec-4d59-9c0d-9f2fc088db35/artifacts/528cb74a_logo.jpg"
        alt="SS Consultancy Logo"
        style={{ height: '2.5rem', width: 'auto', filter: 'brightness(0) invert(1)' }}
      />
      <div>
        <h4 style={{ fontSize: '1.2rem', fontWeight: 700 }}>{companyInfo.name}</h4>
        <p style={{ fontSize: '0.8rem', opacity: 0.8 }}>{companyInfo.tagline}</p>
      </div>
    </div>

    <p style={{ marginBottom: '1.25rem', lineHeight: 1.6, color: 'rgba(255,255,255,0.78)', fontSize: '0.875rem' }}>
      Independent, AMFI-registered financial advisory serving individuals and businesses across
      Chandannagar, Chinsurah and the Hooghly region.
    </p>

    <div style={{ marginBottom: '1.25rem' }}>
      <SocialIcons variant="dark" size={16} />
    </div>

    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', color: 'rgba(255,255,255,0.85)' }}>
      <MapPin size={16} style={{ marginTop: '2px' }} />
      <span style={{ fontSize: '0.85rem' }}>{companyInfo.address}</span>
    </div>
  </div>
);
